<loading-spinner class="loading-spinner" [loading]="loading"></loading-spinner>
<div *ngIf="!loading">
  <div class="question" *ngFor="let qa of qaAnswer!">
    <h2>{{ qa.question }}</h2>
    <span *ngFor="let answer of qa.answers">{{ answer + ' ' }}</span>
    <span *ngIf="qa.answers.length === 0">回答なし</span>
  </div>
</div>
